






import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: "QrTool"
})
export default class QrTool extends Vue {

}
